var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJira({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.112 11.44l-8.606-8.606L11.672 2 5.194 8.479 2.23 11.44a.794.794 0 000 1.12l5.919 5.919L11.672 22l6.478-6.479.1-.1 2.862-2.857a.792.792 0 000-1.124zm-9.44 3.517L8.715 12l2.957-2.957L14.628 12l-2.956 2.957z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.673 9.043a4.978 4.978 0 01-.022-7.019l-6.47 6.468 3.521 3.522 2.97-2.97z",
    fill: "url(#jira_svg__paint0_linear_3708:33666)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.636 11.992l-2.964 2.966a4.98 4.98 0 010 7.04l6.488-6.484-3.524-3.522z",
    fill: "url(#jira_svg__paint1_linear_3708:33666)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira_svg__paint0_linear_3708:33666",
    x1: 11.143,
    y1: 6.051,
    x2: 7.014,
    y2: 10.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira_svg__paint1_linear_3708:33666",
    x1: 755.566,
    y1: 870.239,
    x2: 1177.23,
    y2: 1143.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}

export default SvgJira;